// Grafiektype 'Getal' voor een schaalvraag: het gemiddelde als groot getal.
//
// Nodig omdat de gewone weergave van één meetmoment het gemiddelde als klein
// getal op een dun lijntje zet, met veel lege ruimte en zonder n. In een
// rapportage leest een rapportcijfer beter als cijfer (testronde 2026-10-05).

import MetricVisualization from '../dataVisualizations/MetricVisualization'

const formatter = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 1, maximumFractionDigits: 1 })

/**
 * @typedef {object} ScaleMoment
 * @property {string} moment - Naam van het meetmoment
 * @property {string|number} average - Gemiddelde (ScaleData levert een string met twee decimalen)
 */

/**
 * @param {object} props
 * @param {ScaleMoment[]} props.groupedData - Gemiddelde per meetmoment
 * @param {number} props.totalResponses - Aantal invullingen (n)
 */
const ScaleMetric = ({ groupedData, totalResponses }) => {
    const single = groupedData.length < 2

    return (
        <div className="scale-metric">
            <p className="chart-sample-size">n = {totalResponses}</p>
            <div className="scale-metric-values">
                {groupedData.map(moment => (
                    <MetricVisualization
                        key={moment.moment}
                        value={Number(moment.average)}
                        label={single ? 'Gemiddeld' : moment.moment}
                        formatValue={(v) => formatter.format(v)}
                    />
                ))}
            </div>
        </div>
    )
}

export default ScaleMetric
